export default {
    'FETCH_TAXES' (state, data) {
        state.taxes = data;
  }
}